import request from '@/utils/http';
// 回单签收列表数据
export const getSignList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/selModels`,
        method: 'get',
        params
    });
};

// 回单移交列表数据
export const getTrueOverList = (params) => {
    return request({
        url: `/api-srm-web/order/ltms/selTransfer`,
        method: 'get',
        params
    });
};

// 回单签收-查看附件
export const selFile = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/selFile`,
        method: 'post',
        data
    });
};

// 回单签收-文件上传
export const fileUpload = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/fileUpload`,
        method: 'post',
        data
    });
};

// 回单签收-文件上传-确定
export const saveFile = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveFile`,
        method: 'post',
        data
    });
};

// 回单移交-生成移交单
export const saveTransfer = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveTransfer`,
        method: 'post',
        data
    });
};

// 回单签收-回单逾期
export const saveReceiptOverDueReason = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveReceiptOverDueReason`,
        method: 'post',
        data
    });
};

// 回单签收-到货逾期
export const saveArriveOverDueReason = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/saveArriveOverDueReason`,
        method: 'post',
        data
    });
};